import { render, staticRenderFns } from "./tbody.vue?vue&type=template&id=97f27bfa&"
import script from "./tbody.vue?vue&type=script&lang=js&"
export * from "./tbody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports